import { Controller } from "@hotwired/stimulus"

// Entry popup: "N customers need bringing back". Opens once on the dashboard,
// then stays quiet until a NEW customer crosses into the dormant list.
//
// "New one" is decided by a high-water mark: the server's newest dormant moment
// (data-newest, epoch seconds — see RebookingMetrics#newest_dormant_at), which
// only climbs as customers enter the bring-back list. On close we remember it and
// reopen only when the server's value is greater. Per device (localStorage),
// matching the pwa/push banners.
const SEEN_KEY = "retention-notified-at"

export default class extends Controller {
  static values = { newest: Number }

  connect() {
    // <dialog> is the element itself. Nothing new since last dismiss → stay shut.
    if (!this.newestValue || this.newestValue <= this.seen) return
    this.element.showModal()
  }

  // Fires on EVERY close of the native <dialog> — the button below, Esc, or a
  // form-method="dialog" submit all funnel through here, so the high-water mark
  // is recorded however the owner dismisses it. (No backdrop-click close: native
  // <dialog> doesn't do that, and we don't add it — button + Esc is enough.)
  remember() {
    try {
      localStorage.setItem(SEEN_KEY, String(this.newestValue))
    } catch {
      // Safari private mode throws on setItem; popup just reappears next load.
    }
  }

  // Dismiss button → close the dialog, which fires the native `close` event that
  // remember() listens for. Don't persist here directly: Esc must persist too.
  dismiss() {
    this.element.close()
  }

  get seen() {
    try {
      return Number(localStorage.getItem(SEEN_KEY)) || 0
    } catch {
      return 0
    }
  }
}
